export class ReturnTransactionContractRequestModel {
    contractNumber: string;
    administrationSurcharge: number;

    /**
     *
     */
    constructor() {
        this.contractNumber = "";
        this.administrationSurcharge = 0;
    }
}